/* -------------------------------------------------------------------------- */
/*                               Schema Locations                             */
/* -------------------------------------------------------------------------- */

import { schema } from 'normalizr';

export const driver = new schema.Entity('drivers', {}, { idAttribute: 'driverId' });
export const drivers = new schema.Array(driver);
